export const url = Object.freeze({
    GOOGLE: 'https://google.com',
    IMGUR: 'https://i.imgur.com',
    MAL: 'https://myanimelist.net/anime/',
    ANI_DB: 'https://anidb.net/anime/',
    BASE: 'https://us-central1-futa-a0ad8.cloudfunctions.net/server'
});

export const route = Object.freeze({
    LIST: 'list',
    COVERS: 'covers',
    DISCLAIMER: 'disclaimer',
    ERROR: 'error'
});

export const serviceData = Object.freeze({
    TOKEN_KEY: '_data_'
});

export const firebaseConfig = Object.freeze({
    apiKey: "AIzaSyBOceBxONlcR4sA0HxauK3AEq65RoAfzJY",
    authDomain: "futa-a0ad8.firebaseapp.com",
    databaseURL: "https://futa-a0ad8.firebaseio.com",
    projectId: "futa-a0ad8",
    storageBucket: "futa-a0ad8.appspot.com",
    messagingSenderId: "239345918409",
    appId: "1:239345918409:web:19c0c4d674064efaa14818",
    measurementId: "G-NS1M8X31R8"
});
